import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["expireDate"];
import { fromJS } from 'immutable';
import { useCallback } from 'react';
import http from 'hub-http/clients/apiClient';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { getDemographicsDataForUser, setDemographicsDataForUser } from '../utils/recommendations/recommendationStorageUtils';
const getDemographicsData = userId => {
  var _fromStorage$user;
  const fromStorage = getDemographicsDataForUser(userId);
  const _ref = fromStorage || {},
    {
      expireDate
    } = _ref,
    storedData = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isExpired = !expireDate || expireDate < new Date();
  if (fromStorage && (_fromStorage$user = fromStorage.user) !== null && _fromStorage$user !== void 0 && _fromStorage$user.assignedPersona && !isExpired) {
    return Promise.resolve(storedData);
  }
  return http.get('demographics/v1').then(res => {
    setDemographicsDataForUser(userId, res);
    return res;
  });
};
export const useAsyncDemographicData = userId => {
  const fetcher = useCallback(() => getDemographicsData(userId), [userId]);
  return useAsyncFetcher({
    fetcher
  });
};
export const useAsyncNavPersona = () => {
  const fetcher = useCallback(() => http.get('navpersona/depot/v2'), []);
  return useAsyncFetcher({
    fetcher
  });
};
const getDashboardById = dashboardId => http.get(`dashboard/v2/dashboard/${dashboardId}`, {
  query: {
    hydrate: ['WIDGET']
  }
}).then(fromJS);
export const useAsyncSavedDashboard = dashboardId => {
  const fetcher = useCallback(() => dashboardId ? getDashboardById(dashboardId) : Promise.resolve(null), [dashboardId]);
  return useAsyncFetcher({
    fetcher
  });
};